import template from './raw-materials.html';
import controller from './raw-materials.controller';
import './raw-materials.scss';

let RawMaterialsComponent = {
  bindings: {},
  template,
  controller
};

export default RawMaterialsComponent;



// WEBPACK FOOTER //
// ./src/app/pages/raw-materials/raw-materials.component.js